import { render } from "./FeaturesSection.vue?vue&type=template&id=5c566a96&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"

import "./FeaturesSection.vue?vue&type=style&index=0&id=5c566a96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c566a96"]])

export default __exports__